<template lang="html">
  <div id="products-page">

    <section class="products-section">
      <div class="container oversized-container content">
        <h2 class="common-title">{{ $t("shared.titles.products") }}</h2>

        <div class="row">

          <div class="col-sm-6 col-lg-4 col-product-sample-v2" v-for="(product, pjInx) in products" :key="'pjInx-'+pjInx">
            <router-link class="pj-link" :to="'/productos/categoria/'+product.id">
              <div class="placed-backg box-img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                <img src="public/images/shared/article.png">
              </div>
              <div class="box-info">
                  <h5>{{ product.name }}</h5>
              </div>
            </router-link>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      products: [
       /* { id: 1, name: 'Ventanas', image: 'public/images/pages/products/product-1.jpg' },
        { id: 2, name: 'Canceles de Baño', image: 'public/images/pages/products/product-2.jpg' },
        { id: 3, name: 'Mosquiteros', image: 'public/images/pages/products/product-3.jpg' },
        { id: 4, name: 'Persinas Enrollables', image: 'public/images/pages/products/product-4.jpg' },
        { id: 5, name: 'Canceles de Baño', image: 'public/images/pages/products/product-5.jpg' },
        { id: 6, name: 'Vidrios', image: 'public/images/pages/products/product-5.jpg' },
        { id: 7, name: 'Ventanas', image: 'public/images/pages/products/product-1.jpg' },
        { id: 8, name: 'Canceles de Baño', image: 'public/images/pages/products/product-2.jpg' },*/
      ],
    }
  },
  methods: {
      getCategoriesProducts: function(){
        axios.get(tools.url('/categoriesFrontProducts')).then(
          ({data}) =>{
            this.products=data;
          });
      }
  },
  mounted() {
       this.getCategoriesProducts();
  }
}
</script>
